import { useIntl } from "react-intl";

interface IPropsUseTranslation {
  id: string;
}

const useTranslation = (props: IPropsUseTranslation, values?: any) => {
  const intl = useIntl();
  return intl.formatMessage({ id: props.id }, values);
};

export default useTranslation;
